import './main.less';
import PropTypes from 'prop-types';
import React from 'react';
import {Field, getFormValues, reduxForm} from 'redux-form';
import { Link } from 'react-router';

import CustomizableBlock from '../../../../shared/customizable-block';
import LangSwitch from '../../../../shared/lang/switch';
import InputField from '../../../../shared/form-elements/input';
import TextField from '../../../../shared/form-elements/textarea';
import CheckboxField from '../../../../shared/form-elements/checkbox';
import SelectField from '../../../../shared/form-elements/select/field';
import UploadField from '../../../../shared/form-elements/upload';
import RichTextField from '../../../../shared/form-elements/rich-text';
import DatePicker from '../../../../shared/form-elements/date-picker/main';
import { connect } from 'react-redux';
import _get from 'lodash/get';

const HOME_PAGE_OFFERS_COUNT = 27;

const isRocket = process.env.CPA_ENV === 'rocket';

const Main = props => {
	const { shouldTranslate, selectOptions, disabledFields } = props.mainFormData;
	const isShowedExternalOfferPaymentType = !!_get(
		props, 'programsMainFormValues.external_integration.length'
	);
	const {
		count_on_page_en,
		count_on_page_ru,
		is_on_home_page_en,
		is_on_home_page_ru
	} = props.mainFormData.initialValues;

	const submit = data => shouldTranslate ? props.mainFormSubmitTranslation(data) : props.mainFormSubmit(data);
	const shouldDisabled = prepareDisabledFields(disabledFields);
	const isEverad = process.env.CPA_ENV === 'everad';
	return (
		<div className="offers-form-wrap">
			<div className="offers-form-wrap__langs">
				<LangSwitch langs={props.mainTabLangs} onChangeLang={props.mainFormChangeLanguage}/>
			</div>
			<form className="ui-form offers-form__main clearfix" onSubmit={props.handleSubmit(submit)}>
				<div className="offers-form__main-fields">
					<div className="ui-form__element">
						<Field
							name="title"
							placeholder={ props.intl('Title') }
							disabled={shouldDisabled('title')}
							component={InputField} />
					</div>

					<div className="ui-form__element">
						<Field
							name="product_name"
							placeholder={ props.intl('Product') }
							disabled={true}
							component={InputField} />
					</div>
					<div className="ui-form__element">
						<Field
							name="crm_title"
							placeholder={ props.intl('Title CRM') }
							disabled={true}
							component={InputField} />
					</div>

					<div className="ui-form__element">
						<Field
							name="subtitle"
							placeholder={ props.intl('Subtitle') }
							disabled={shouldDisabled('subtitle')}
							component={InputField} />
					</div>

					<div className="ui-form__element">
						<Field
							name="comment"
							placeholder={ props.intl('Comment') }
							disabled={shouldDisabled('comment')}
							component={InputField} />
					</div>

					{!isRocket && (
						<div className="ui-form__element">
							<Field
								name="alternative_titles"
								placeholder={ props.intl('Alternative titles') }
								disabled={shouldDisabled('alternative_titles')}
								format={val => val && val.join(', ')}
								normalize={val => val && val.split(', ')}
								component={InputField} />
						</div>
					)}

					<div className="ui-form__element">
						<Field
							name="domain"
							placeholder={ props.intl('Domain') }
							disabled={shouldDisabled('domain')}
							component={InputField} />
					</div>

					{!isRocket && (
						<div className="ui-form__element">
							<Field
								name="preview_domain"
								placeholder={ props.intl('Preview domain') }
								component={InputField} />
						</div>
					)}
					<CustomizableBlock settingId='offer-past-manual' top={4}>
						<div className="ui-form__element">
							<Field
								name="past_approve_leads_per_day"
								placeholder={ props.intl('Minimum leads per day for past manual approve') }
								component={InputField} />
						</div>
					</CustomizableBlock>
					{
						isEverad &&
						<div className="ui-form__element">
							<Field
								name="tags"
								placeholder={ props.intl('Tags') }
								format={val => val && val.join(', ')}
								normalize={val => val && val.split(', ')}
								component={InputField} />
						</div>
					}
					{
						props.payoutCurrencies.map((currency, index) =>
							<div className="ui-form__element" key={index}>
								<Field
									name={`max_payout_${currency}`}
									placeholder={ props.intl(`Max payout ${currency}`) }
									component={InputField} />
							</div>
						)
					}
					{
						isEverad && (
							<div className="ui-form__element">
								<Field
									name="is_new"
									placeholder={props.intl('NEW Offer')}
									disabled={true}
									normalize={v => !!v}
									needShowWhenDisabled={true}
									component={CheckboxField}
								/>
							</div>
						)
					}
					{
						isEverad && (
							<div className="ui-form__element">
								<Field
									name="is_test"
									placeholder={props.intl('Is test')}
									normalize={v => !!v}
									component={CheckboxField}
								/>
							</div>
						)
					}
					{
						isEverad && (
							<div className="ui-form__element">
								<Field
									name="niche"
									placeholder={ props.intl('Niche') }
									component={SelectField}
									searchable={false}
									disabled={shouldDisabled('niche')}
									options={selectOptions['niche']} />
							</div>
						)
					}
					{isEverad ? (
						<div className="ui-form__element">
							<Field
								name="category"
								placeholder={ props.intl('Category') }
								component={SelectField}
								searchable={false}
								disabled={shouldDisabled('category')}
								options={selectOptions['categories']} />
						</div>
					) : (
						<div className="ui-form__element">
							<Field
								name="category_id"
								placeholder={ props.intl('Category') }
								component={SelectField}
								disabled={shouldDisabled('category_id')}
								options={props.categoriesLookupsRP} />
						</div>
					)}

					<div className="ui-form__element">
						<Field
							name="status"
							placeholder={ props.intl('Status') }
							component={SelectField}
							searchable={false}
							disabled={shouldDisabled('status')}
							options={props.mainFormData.selectOptions['statuses']} />
					</div>

					<div className={`ui-form__element ${isEverad && 'rules__editor'}`}>
						<Field
							name="rules"
							placeholder={ props.intl('Rules') }
							disabled={shouldDisabled('rules')}
							component={isEverad ? RichTextField : TextField} />
					</div>

					<div className="ui-form__element">
						<Field
							name="crm_id"
							placeholder={ props.intl('CRM id') }
							disabled={shouldDisabled('crm_id')}
							component={InputField} />
					</div>

					<div className="ui-form__element">
						<Field
							name="additional_crm_id"
							placeholder={ props.intl('Additional CRM id') }
							disabled={shouldDisabled('additional_crm_id')}
							component={InputField} />
					</div>

					<div className="ui-form__element">
						<Field
							name="additional_crm_offer_country_id"
							placeholder={ props.intl('Additional CRM offer country_id') }
							disabled={shouldDisabled('additional_crm_offer_country_id')}
							component={SelectField}
							multi={false}
							showLabel={false}
							options={props.locationsLookup} />
					</div>

					<div className="ui-form__element">
						<Field
							name="analog_ids"
							placeholder={ props.intl('Analog offer id') }
							disabled={shouldDisabled('analog_offer_id')}
							component={SelectField}
							multi={true}
							showLabel={false}
							options={props.analogOffersLookup} />
					</div>

					<div className="ui-form__element">
						<Field
							name="priority"
							placeholder={ props.intl('Priority') }
							component={SelectField}
							searchable={false}
							options={props.mainFormData.selectOptions['offerPrioritiesEnum']} />
					</div>

					<div className="ui-form__element">
						<Field
							name="sale_model"
							placeholder={ props.intl('Sale model') }
							component={SelectField}
							searchable={false}
							disabled={shouldDisabled('sale_model')}
							options={props.mainFormData.selectOptions['saleModels']} />
					</div>
					{
						isShowedExternalOfferPaymentType && (
							<div className="ui-form__element">
								<Field
									name="external_offer_payment_type"
									placeholder={ props.intl('External offer payment type') }
									component={SelectField}
									searchable={false}
									options={props.mainFormData.selectOptions['externalOfferPaymentType']} />
							</div>
						)
					}

					<div className="ui-form__element buttons-wrap">
						{ props.can('edit') && (
							<button className="ui-btn ui-btn-primary">{ props.intl('Save') }</button>
						)}

						<Link to='programs/' className="ui-btn ui-btn-cancel">{ props.intl('Cancel') }</Link>
					</div>
				</div>

				<div className="offers-form__main-meta">
					<div className="ui-form__element">
						<Field
							name="image"
							component={UploadField}
							placeholder={ props.intl('Upload') }
							disabled={shouldTranslate}
							preparationFile={props.preparationFile}/>
					</div>

					<CustomizableBlock className="checkbox-wrap" settingId='offer-attributes' top={1}>
						<p>{ props.intl('Attributes of the offer') }</p>

						{!isRocket && (
							<div className="ui-form__element">
								<Field
									name="is_exclusive"
									placeholder={props.intl('Is exclusive')}
									disabled={shouldDisabled('is_exclusive')}
									normalize={v => !!v }
									component={CheckboxField}
								/>
								<Field
									name="access_on_request"
									placeholder={props.intl('Access on request')}
									disabled={shouldDisabled('access_on_request')}
									normalize={v => !!v }
									component={CheckboxField}
								/>
								<Field
									name="is_top_offer"
									placeholder={props.intl('Top offer')}
									disabled={shouldDisabled('is_top_offer')}
									normalize={v => !!v }
									component={CheckboxField}
								/>

								<div>
									<p>
										{ props.intl('Show on homepage') }
									</p>
									<div className="checkbox_with_counter">
										<Field
											name="is_on_home_page_ru"
											placeholder={props.intl('ru')}
											count={props.intl(count_on_page_ru)}
											normalize={v => !!v }
											disabled={count_on_page_ru >= HOME_PAGE_OFFERS_COUNT && !is_on_home_page_ru}
											component={CheckboxField} />
										<div className={`counter-message 
											${count_on_page_ru >= HOME_PAGE_OFFERS_COUNT ? 'warning': ''}`}>
											{`${count_on_page_ru} selected from ${HOME_PAGE_OFFERS_COUNT}`}
										</div>
									</div>
									<div className="checkbox_with_counter">
										<Field
											name="is_on_home_page_en"
											placeholder={props.intl('en')}
											count={props.intl(count_on_page_en)}
											normalize={v => !!v }
											disabled={count_on_page_en >= HOME_PAGE_OFFERS_COUNT && !is_on_home_page_en}
											component={CheckboxField} />
										<div className={`counter-message 
											${count_on_page_en >= HOME_PAGE_OFFERS_COUNT ? 'warning': ''}`}>
											{`${count_on_page_en} selected from ${HOME_PAGE_OFFERS_COUNT}`}
										</div>
									</div>
								</div>
							</div>
						)}
						<div className="ui-form__element">
							<Field
								name="external_integration"
								placeholder={props.intl('External integration')}
								disabled={shouldDisabled('external_integration')}
								searchable={false}
								component={SelectField}
								options={props.mainFormData.selectOptions.externalIntegrations}
							/>
						</div>
						<div className="ui-form__element">
							<Field
								name="use_redirect"
								placeholder={props.intl('Use redirect (for external_integration)')}
								disabled={shouldDisabled('use_redirect')}
								normalize={v => !!v }
								component={CheckboxField}
							/>
						</div>
						{isRocket && window.globalConfig && window.globalConfig.isDateOfLastRecallCampaignEnabled && (
							<div className="ui-form__element">
								<div className="offers-form__field">
									{props.intl('Date of last recall campaign')}:
								</div>
								<Field
									className="offers-form__field__date-picker"
									name='date_of_last_recall_campaign'
									component={DatePicker}
									isResetAllowed
								/>
							</div>
						)}
					</CustomizableBlock>
				</div>
			</form>
		</div>
	);
};

Main.propTypes = {
	mainTabLangs: PropTypes.array,
	mainFormData: PropTypes.object,
	handleSubmit: PropTypes.func,
	mainFormSubmit: PropTypes.func,
	mainFormSubmitTranslation: PropTypes.func,
	mainFormChangeLanguage: PropTypes.func,
	preparationFile: PropTypes.func,
	intl: PropTypes.func,
	can: PropTypes.func,
	admin: PropTypes.object
};

const prepareDisabledFields = disabledFields => fieldName => disabledFields.indexOf(fieldName) > -1;

export default connect(state => ({
	programsMainFormValues: getFormValues('programsMainForm')(state)
}))(reduxForm({
	form: 'programsMainForm'
})(Main));



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/programs/components/forms/general/main.js